import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from '@react-pdf/renderer';
import ibmLogo from '../assets/images/logo.png';
import { roiCookieContent } from './SterlingBVAROI';
import { useIntl } from 'react-intl';

interface rangeType {
  incOnlineSales: number;
  incStoreSaleReduce: number;
  reduceReturn: number;
  reduceMarkdownCosts: number;
  reduceShippingCosts: number;
}

export interface SterlingBVAROIEstimatorProps {
  imgSummary: string;
  imgSummary1: string;
  cookieContent: roiCookieContent;
  dataInputTitles: string[];
  range: rangeType;
}
export const PDFGenerate = ({
  imgSummary,
  imgSummary1,
  cookieContent,
  dataInputTitles,
  range,
}: SterlingBVAROIEstimatorProps) => {
  const intl = useIntl();
  const styles = StyleSheet.create({
    page: { backgroundColor: '#f4f4f4', paddingTop: 30 },
    section: {
      fontSize: 10,
      textAlign: 'justify',
      width: 500,
      marginLeft: 50,
      marginRight: 50,
    },
    viewFlex: {
      display: 'flex',
      flexDirection: 'row',
      paddingTop: 10,
    },
    viewFlex1: {
      display: 'flex',
      lineHeight: 2.2,
      flexDirection: 'row',
    },
    textInputs: {
      fontSize: 8,
      lineHeight: 1.5,
      width: 100,
      marginTop: 5,
      textAlign: 'center',
    },
    valueInputs: {
      backgroundColor: '#D3D3D3',
      width: 100,
      textAlign: 'center',
      paddingTop: 5,
    },
    textTotal: {
      backgroundColor: '#D3D3D3',
      color: 'blue',
      width: 100,
      lineHeight: 2,
      paddingTop: 5,
      textAlign: 'center',
      height: 25,
    },
    paragraph: { paddingTop: 10, paddingBottom: 10 },
    paragraph1: { paddingTop: 30 },
    title: { paddingTop: 20, fontSize: 12 },
    paragraphItalics: { fontStyle: 'italic', paddingTop: 20 },
    image: { width: 50, height: 20 },
    imageForResults: {
      width: 420,
      height: 'auto',
    },
    imageForSummary: {
      width: 420,
      height: 'auto',
      marginTop: 40,
    },
  });

  Font.registerHyphenationCallback((word) => [word]);

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={[styles.section]}>
          <Image style={styles.image} src={ibmLogo} />
          <Text style={styles.title}>{dataInputTitles[6]}</Text>
        </View>
        <View style={[styles.section, { marginTop: 15 }]}>
          <Image style={styles.imageForResults} src={imgSummary1} />
        </View>
      </Page>
      <Page size="A4" style={styles.page}>
        <View style={[styles.section]}>
          <Image style={styles.image} src={ibmLogo} />

          <Image style={styles.imageForSummary} src={imgSummary} />

          <Text style={[styles.title, { marginTop: 30 }]}>
            {dataInputTitles[0]}
          </Text>
          <View style={styles.viewFlex}>
            <View>
              <View style={styles.viewFlex1}>
                <Text style={styles.valueInputs}>
                  {cookieContent.totalOnlineSale}
                </Text>
                <Text> x </Text>
                <Text style={styles.valueInputs}>
                  {cookieContent.input.industryAvgProfit / 100}%
                </Text>
              </View>
              <View style={styles.viewFlex1}>
                <Text style={styles.textInputs}>{dataInputTitles[7]}</Text>
                <Text> </Text>
                <Text> </Text>
                <Text> </Text>
                <Text style={styles.textInputs}>{dataInputTitles[8]}</Text>
              </View>
            </View>
            <Text> </Text>
            <Text> </Text>
            <Text> = </Text>
            <View style={styles.textTotal}>
              <Text>{cookieContent.increaseOnlineSalesTotal}</Text>
            </View>
          </View>
          <Text style={[styles.title, { marginTop: 30 }]}>
            {dataInputTitles[1]}
          </Text>
          <View style={styles.viewFlex}>
            <View>
              <View style={styles.viewFlex1}>
                <Text style={styles.valueInputs}>
                  {cookieContent.totalStoreSale}
                </Text>
                <Text> x </Text>
                <Text style={styles.valueInputs}>
                  {cookieContent.input.industryAvgProfit / 100}%
                </Text>
              </View>
              <View style={styles.viewFlex1}>
                <Text style={styles.textInputs}>{dataInputTitles[9]}</Text>
                <Text> </Text>
                <Text> </Text>
                <Text> </Text>
                <Text style={styles.textInputs}>{dataInputTitles[8]}</Text>
              </View>
            </View>
            <Text> </Text>
            <Text> </Text>
            <Text> = </Text>
            <View style={styles.textTotal}>
              <Text>{cookieContent.increaseStoreSalesTotal}</Text>
            </View>
          </View>
          <Text style={[styles.title, { marginTop: 30 }]}>
            {dataInputTitles[2]}
          </Text>
          <View style={styles.viewFlex}>
            <View>
              <View style={styles.viewFlex1}>
                <Text style={styles.valueInputs}>
                  {cookieContent.totalEstAnnualSale}
                </Text>
                <Text> x </Text>
                <Text style={styles.valueInputs}>
                  {cookieContent.input.onlineSalePercentage / 100}%
                </Text>
                <Text> x </Text>
                <Text style={styles.valueInputs}>{range.reduceReturn}%</Text>
              </View>
              <View style={styles.viewFlex1}>
                <Text style={styles.textInputs}>{dataInputTitles[10]}</Text>
                <Text> </Text>
                <Text> </Text>
                <Text> </Text>
                <Text style={styles.textInputs}>{dataInputTitles[11]}</Text>
                <Text> </Text>
                <Text> </Text>
                <Text> </Text>
                <Text style={styles.textInputs}>{dataInputTitles[12]}</Text>
              </View>
            </View>
            <Text> </Text>
            <Text> </Text>
            <Text> = </Text>
            <View style={styles.textTotal}>
              <Text>{cookieContent.reduceReturnsTotal}</Text>
            </View>
          </View>
        </View>
      </Page>
      <Page size="A4" style={styles.page}>
        <View style={[styles.section]}>
          <Text style={[styles.title, { marginTop: 30 }]}>
            {dataInputTitles[3]}
          </Text>
          <View style={styles.viewFlex}>
            <View>
              <View style={styles.viewFlex1}>
                <Text style={styles.valueInputs}>
                  {cookieContent.calcAvgMarkDownCost}
                </Text>
                <Text> x </Text>
                <Text style={styles.valueInputs}>
                  {cookieContent.input.onlineSalePercentage / 100}%
                </Text>
                <Text> x </Text>
                <Text style={styles.valueInputs}>
                  {range.reduceMarkdownCosts}%
                </Text>
              </View>
              <View style={styles.viewFlex1}>
                <Text style={styles.textInputs}>{dataInputTitles[13]}</Text>
                <Text> </Text>
                <Text> </Text>
                <Text> </Text>
                <Text style={styles.textInputs}>{dataInputTitles[11]}</Text>
                <Text> </Text>
                <Text> </Text>
                <Text> </Text>
                <Text style={styles.textInputs}>{dataInputTitles[14]}</Text>
              </View>
            </View>
            <Text> </Text>
            <Text> </Text>
            <Text> = </Text>
            <View style={styles.textTotal}>
              <Text>{cookieContent.reduceMarkDownCostTotal}</Text>
            </View>
          </View>
          <Text style={[styles.title, { marginTop: 30 }]}>
            {dataInputTitles[4]}
          </Text>
          <View style={styles.viewFlex}>
            <View>
              <View style={styles.viewFlex1}>
                <Text style={styles.valueInputs}>
                  {cookieContent.calcAvgShippingCost}
                </Text>
                <Text> x </Text>
                <Text style={styles.valueInputs}>
                  {range.reduceShippingCosts}%
                </Text>
              </View>
              <View style={styles.viewFlex1}>
                <Text style={styles.textInputs}>{dataInputTitles[15]}</Text>
                <Text> </Text>
                <Text> </Text>
                <Text> </Text>
                <Text style={styles.textInputs}>{dataInputTitles[16]}</Text>
              </View>
            </View>
            <Text> </Text>
            <Text> </Text>
            <Text> = </Text>
            <View style={styles.textTotal}>
              <Text>{cookieContent.reduceShippingCostTotal}</Text>
            </View>
          </View>
        </View>
        <View style={styles.section}>
          <Text style={styles.paragraph1}>{dataInputTitles[5]}</Text>
        </View>
      </Page>
    </Document>
  );
};
